angular.module("SupportAgent")
.controller(
 'SupportQueueController',
 ['$scope','$rootScope','$location',
  'L','INTERACT',
 function ($scope,$rootScope,$location,L,INTERACT) {
  $rootScope.menutitle = "Digital Support"; // TODO: why is this here?!

  // { group_by: function(c), where: function(c) }
  function aggregateConversations(pp) {
   if(!pp) pp={};
   return INTERACT.get_conversations(pp.where).reduce(function(p,c) {
    var gb = pp.group_by(c);
    var g = gb.slice(0,-1).reduce(function(p,c) {
     return p[c] ? p[c] : (p[c] = {});
    },p);
    var last = gb.pop();
    if(!g[last]) g[last] = [c];
    else g[last].push(c);
    return p;
   },{});
  }

  function update_conversations() {
   var myself = INTERACT.get_myself();
   if(!myself) return L.warn("we're not yet self-aware, it's too soon to update our conversation, this is most likely because we're routed directly to the support page, but do check.");
   var selfid = INTERACT.get_myself().id;
   var agg = aggregateConversations({
    where: function(c) { return c.is_alive() || c.gid },
    group_by: function(c) {
     if(c.gid) return ['queue',c.gid];
     if(c.is_pending())
      L.warn({c:c},"pending conversation with no group to it");
     var mine = (c.p.indexOf(selfid))>=0;
     var ac = mine ? c.p.find(function(x){return x!=selfid})
                   : c.get_supportee();
     if(!ac) return L.warn({c:c},"conversation with agents only"),['mi6'];
     return [
      mine ? 'mine' : 'unmine',
      ac.id || ac
     ];
    }
   });
   L.debug({agg:agg},"WIP: aggregated conversations");
   $scope.ongoings = ['mine','unmine'].reduce(function(rv,i) {
    if(!agg[i]) return rv;
    rv[i] = Object.keys(agg[i]).map(function(acid) {
     var c = agg[i][acid];
     var ac = INTERACT.get_account(acid);
     if(!ac) return L.warn({acid:acid},"unknown account"),null;
     return {
      c: c,
      display_name: ac.get_display_full_name(),
      acid: acid
     };
    }).filter(function(x){return x});
    return rv;
   },{}); // TODO: it's best served sorted by recency, probably

   var pendings = agg.queue && Object.keys(agg.queue).map(function(gid) {
    var g = INTERACT.get_group(gid);
    return agg.queue[gid].map(function(c) {
     var sptee;
     var ac = (sptee=c.get_supportee())||c.get_participants()[0];
     if(!sptee) L.warn({c,ac},"conversation with no supportee in the queue");
     else if(!ac) return L.error({c},"conversation with no paticipants (yet?)");
     return {
      c: c,
      display_name: ac.get_display_full_name(),
      acid: ac.id,
      group: g.name
     };
    }).filter(function(x){return x});
   }).reduce(function(p,c) {
    return p.concat(c);
   },[]);
   if(pendings) pendings.sort(function(a,b) {
    return +a.ts - +b.ts;
   });
   $scope.pendings = pendings||[];
  }

  var uc_timeout = undefined;
  $scope.$on('wtg.conversations',function on_wtg_conversations() {
   if(uc_timeout) clearTimeout(uc_timeout);
   uc_timeout = setTimeout(function() {
    uc_timeout = undefined;
    $scope.$apply(update_conversations);
   },500);
  });
  $scope.$broadcast('wtg.conversations');

  $scope.dequeue = function dequeue(ticket) {
   ticket.c.select_queued().add_participant(INTERACT.get_myself()).update({
    status: INTERACT.D.conversation.status.ongoing
   });
   // TODO: I very much doubt we should be both requesting status change
   // **AND** updating it ourselves, it should probably be done by dear
   // interact.
   ticket.c.request_status_change(INTERACT.D.conversation.status.ongoing);
   $rootScope.retrievedTransactions({convid:ticket.c.id});
   /* TODO: ideally, though, we should just navigate when dequeueing and only
    * then upon navigation to the queued ticket do all that magic. Also at that
    * same event we should be retrieving transactions */
   $location.path('/support/'+ticket.acid+'/'+ticket.c.id);
  };

 }]);
/* vim:set ts=8 sw=1 expandtab: */
